import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

// Components
import Button from '@atoms/Button';
import { ButtonOutlineLarge, H3, Input } from '@styled';

// Functionality
import { GlobalModalContext } from '@context/globalModalContext';
import { mapSavedSearchToGraph } from '@general/transforms/savedSearch.transform';
import useEditSavedSearch from '@hooks/useEditSavedSearch';

export const useSavedSearchTitleModal = () => {
    const [, setIsModalOpen, setModalChildren] = useContext(GlobalModalContext);

    const openModal = (savedSearch, onSave = () => {}) => {
        setModalChildren(() => (
            <SavedSearchTitleModal
                savedSearch={savedSearch}
                onSave={() => {
                    setIsModalOpen(false);
                    onSave();
                }}
                closeModal={() => setIsModalOpen(false)}
            />
        ));

        setIsModalOpen(true);
    };

    return { openModal };
};

const SavedSearchTitleModal = ({ closeModal, savedSearch, onSave }) => {
    const [newTitle, setNewTitle] = useState(savedSearch.title);
    const { updateSavedSearch } = useEditSavedSearch();

    const save = async () => {
        updateSavedSearch({
            variables: {
                ...mapSavedSearchToGraph({
                    ...savedSearch,
                    title: newTitle,
                }),
            },
        });

        onSave();
    };

    return (
        <>
            <H3 className="mb-1rem">Update Match Criteria Title</H3>

            <div className="mb-2rem">
                <Input className="p-1rem w-full" value={newTitle} onChange={e => setNewTitle(e.target.value)} />
            </div>

            <div className="d-flex">
                <Button buttonClasses="mr-3" onClick={() => save()}>
                    Save
                </Button>
                <ButtonOutlineLarge onClick={closeModal}>Cancel</ButtonOutlineLarge>
            </div>
        </>
    );
};

SavedSearchTitleModal.propTypes = {
    savedSearch: PropTypes.shape({
        title: PropTypes.string.isRequired,
    }).isRequired,
    onSave: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
};

export default SavedSearchTitleModal;
